/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { colListRoutes } from './pages/col-list/col-list.routes';
import { newsRoutes } from './pages/news/news.routes';
import { preferencesRoutes } from './pages/preferences/preferences.routes';
import { clubsRoutes } from './pages/clubs/clubs.routes';
import { clubMembersRoutes } from './pages/clubs/club-members/club-members.routes';
import { clubAddRoutes } from './pages/clubs/club-add/club-add.routes';
import { chatRoutes } from './pages/chat/chat.routes';
import { colAdminRoutes } from './pages/col-admin/col-admin.routes';
import { addCollectionRoutes } from './pages/add-collection/add-collection.routes';
import { loginRoutes } from './pages/login/login.routes';
import { signupRoutes } from './pages/signup/signup.routes';
import { userCollectionRoutes } from './pages/user-collection/user-collection.routes';
import { userCollectionItemsRoutes } from './pages/user-collection/user-collection-items/user-collection-items.routes';
import { cardListRoutes } from './pages/user-collection/user-collection-items/card-list/card-list.routes';
import { tradeOptionsRoutes } from './pages/user-collection/trade-options/trade-options.routes';
import { tradeRequestsRoutes } from './pages/user-collection/trade-requests/trade-requests.routes';
import { userCollectionManageRoutes } from './pages/user-collection/user-collection-manage/user-collection-manage.routes';
import { collectionRankRoutes } from './pages/user-collection/collection-rank/collection-rank.routes';
import { helpRoutes } from './pages/preferences/help/help.routes';
import { privacyPolicyRoutes } from './pages/preferences/privacy-policy/privacy-policy.routes';
import { myFavoritesRoutes } from './pages/preferences/my-favorites/my-favorites.routes';
import { profileRoutes } from './pages/preferences/profile/profile.routes';
import { termsOfUseRoutes } from './pages/preferences/terms-of-use/terms-of-use.routes';
import { qrCodeRoutes } from './pages/qr-code/qr-code.routes';
import { historyRoutes } from './pages/history/history.routes';
import { onboardingRoutes } from './pages/onboarding/onboarding.routes';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'col-list',
    pathMatch: 'full',
  },
  {
    path: 'col-list',
    children: [
      {
        path: '',
        children: colListRoutes,
      },
      {
        path: 'full-list',
        children: colListRoutes,
      },
    ],
  },
  {
    path: 'news',
    children: newsRoutes,
  },
  {
    path: 'preferences',
    children: preferencesRoutes,
  },
  {
    path: 'clubs',
    children: [
      {
        path: '',
        children: clubsRoutes,
      },
      {
        path: ':id',
        children: [
          {
            path: 'club-members',
            children: [
              {
                path: '',
                children: clubMembersRoutes,
              },
            ],
          },
        ],
      },
      {
        path: 'club-add',
        children: clubAddRoutes,
      },
    ],
  },
  {
    path: 'chat',
    children: chatRoutes,
  },
  {
    path: 'col-admin',
    children: colAdminRoutes,
  },
  {
    path: 'add-collection',
    children: addCollectionRoutes,
  },
  {
    path: 'login',
    children: loginRoutes,
  },
  {
    path: 'signup',
    children: signupRoutes,
  },
  {
    path: 'user-collection',
    children: [
      {
        path: '',
        children: userCollectionRoutes,
      },
      {
        path: ':agent_id/:col_id/:user_col_id',
        children: [
          {
            path: 'col-items',
            children: [
              {
                path: ':agent_id/:col_id/:user_col_id',
                children: userCollectionItemsRoutes,
              },
              {
                path: 'card-list',
                children: cardListRoutes,
              },
              {
                path: '*',
                children: userCollectionItemsRoutes,
              },
            ],
          },
          {
            path: 'trade-options',
            children: [
              {
                path: ':agent_id/:col_id/:user_col_id',
                children: tradeOptionsRoutes,
              },
              {
                path: '',
                children: tradeOptionsRoutes,
              },
            ],
          },
          {
            path: 'trade-requests',
            children: [
              {
                path: ':agent_id/:col_id/:user_col_id',
                children: tradeRequestsRoutes,
              },
              {
                path: ':agent_id/:col_id/:user_col_id/:trade_request_id',
                children: tradeRequestsRoutes,
              },
              {
                path: '',
                children: tradeRequestsRoutes,
              },
            ],
          },
          {
            path: 'col-manage',
            children: userCollectionManageRoutes,
          },
          {
            path: 'collection-rank',
            children: collectionRankRoutes,
          },
        ],
      },
    ],
  },

  {
    path: 'preferences',
    children: [
      {
        path: '',
        children: preferencesRoutes,
      },
      {
        path: 'help',
        children: helpRoutes,
      },
      {
        path: 'help/**',
        children: helpRoutes,
      },
      {
        path: 'privacy-policy/:lang',
        children: privacyPolicyRoutes,
      },
      {
        path: 'my-favorites',
        children: myFavoritesRoutes,
      },
      {
        path: 'profile',
        children: profileRoutes,
      },
      {
        path: 'terms-of-use/:lang',
        children: termsOfUseRoutes,
      },
    ],
  },
  {
    path: 'qr-code',
    children: qrCodeRoutes,
  },
  {
    path: 'history',
    children: historyRoutes,
  },
  {
    path: 'onboarding',
    children: onboardingRoutes,
  },
];
